import React, { ReactNode } from "react";
import { clientConfig } from "app/config";
import { IVWTagging } from "app/thirdParty/IVW/IVWTagging";
import NextHead from "next/head";
import { GlobalAdTagScript } from "app/thirdParty/ads/GlobalAdTagScript";
import { resolveStaticFile } from "app/main/staticFileLinker";
import { Tagmanager } from "app/thirdParty/tagmanager/Tagmanager";
import { Heatmap } from "app/thirdParty/heatmap/Heatmap";

interface Props {
    metaData?: { [name: string]: string };
    title?: string;
    canonicalUrl?: string;
    children?: ReactNode[];
    enableIVW?: boolean;
}

const maxTitleLength = 65;

export const Head = ({ canonicalUrl, children, metaData = {}, title, enableIVW = true }: Props) => {
    const absoluteCanonical = canonicalUrl
        ? canonicalUrl.substr(0, 6) === "https:"
            ? canonicalUrl
            : `${clientConfig.basePath}${canonicalUrl.substr(0, 1) === "/" ? "" : "/"}${canonicalUrl}`
        : canonicalUrl;

    return (
        <>
            <NextHead>
                <link rel="apple-touch-icon" sizes="180x180" href="https://www.t-online.de/apple-touch-icon.png" />
                <link rel="icon" type="image/png" sizes="32x32" href="https://www.t-online.de/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="https://www.t-online.de/favicon-16x16.png" />
                <link rel="mask-icon" href="https://www.t-online.de/safari-pinned-tab.svg" color="#5bbad5" />
                <link rel="shortcut icon" href="https://www.t-online.de/favicon.ico" />
                <meta name="msapplication-TileColor" content="#e20074" />
                <meta name="msapplication-config" content="https://www.t-online.de/browserconfig.xml" />
                {absoluteCanonical && <link rel="canonical" href={absoluteCanonical} />}
                {title && <title>{title.substring(0, maxTitleLength)}</title>}
                {Object.entries(metaData).map(([key, value]) => {
                    return <meta key={`meta-${key}`} name={key} content={value} />;
                })}
                {clientConfig.consentEnabled && (
                    <React.Fragment>
                        <script src={resolveStaticFile("consent.js")}></script>
                        <script src="https://consent.t-online.de/wrapperMessagingWithoutDetection.js"></script>
                    </React.Fragment>
                )}
                {children}
            </NextHead>
            {enableIVW && <IVWTagging />}
            <Tagmanager title={title} />
            {clientConfig.adsEnabled && <GlobalAdTagScript />}
            <Heatmap />
        </>
    );
};
